<div class="ui modal" id="Customer_Card_Message_Modal">

  <div class="header" style="background-color:#DCDCDC">
    <span tkey="INFO"></span>
    <button style="float:right;background-color: white;border: 1px solid;" class="circular ui icon button" (click)="Customer_Card_Message_Modal_Close()">
      <i class="remove link icon"></i>
    </button>
  </div>

  <div class="content" style="height:180px;">
    <span style="font-size: 18px;">{{this.coreService.customerUser?.CustomerCardMessage}}</span>
  </div>
</div>
